export default __webpack_public_path__ + "static/media/LogoSadhana.ef573c33.png";